import { createContext } from "react";

const FilterProductContext = createContext();

export default FilterProductContext;
